module.exports = __webpack_public_path__ + "img/linkedin.e4baedd5.svg";